import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../website/Header';
import Footer from '../website/Footer';
import UseInactivityLogout from '../../utils/UseInactivityLogout';
import CustomPopup from '../../utils/Custompopup';

export default function Layout({headerKey, reloadHeader}) {
  const { isPopupVisible,  handleLogout } = UseInactivityLogout();

  return (
    <>
    <Header headrKey={String(headerKey)} />
      <div className="app-body">
        <Outlet reloadHeader={reloadHeader} />
        {!['/forgot-password', '/login','/signup','/', '/home', '/Dashboard'].includes(window.location.pathname) && <Footer />}
      </div>
      {isPopupVisible && (
        <CustomPopup onLogout={handleLogout} />
      )}
    </>
  )
}
